import { styled } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import { useAttorneyHubDispatch } from "_shared/_stores/redux-store";
import {
  getCompanyAvatar,
  getCompanyAvatarError,
  getCompanyAvatarIsLoading,
  populateCompanyAvatar,
} from "marketplace/companies/_store/companies-redux-slice";
import Company from "marketplace/companies/company";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const StyledAvatar = styled(Avatar)<{ disabled?: boolean }>(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1,
}));
const LoadingProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[theme.palette.mode === "light" ? 200 : 700],
  height: "75%",
  width: "75%",
}));

type CompanyAvatarProps = {
  className?: string;
  company?: Company;
  disabled?: boolean;
};

export default function CompanyAvatar(props: Readonly<CompanyAvatarProps>) {
  const { className, company, disabled } = props;

  const dispatch = useAttorneyHubDispatch();

  const base64AvatarData = useSelector(getCompanyAvatar(company?.id ?? null));
  const isLoadingAvatar = useSelector(getCompanyAvatarIsLoading(company?.id ?? null));
  const errorLoadingAvatar = useSelector(getCompanyAvatarError(company?.id ?? null));

  useEffect(() => {
    if (!company?.profile?.avatarId || base64AvatarData || isLoadingAvatar || errorLoadingAvatar) return;

    dispatch(populateCompanyAvatar({ companyId: company.id }));
  }, [dispatch, company?.profile?.avatarId?.value, isLoadingAvatar, errorLoadingAvatar, company?.profile?.avatarId, company?.id, base64AvatarData]);

  return (
    <>
      {(base64AvatarData) ? (
        <StyledAvatar
          className={className}
          disabled={disabled}
          src={base64AvatarData}
        >
          {
            !base64AvatarData
            && isLoadingAvatar
            && !errorLoadingAvatar
            && <LoadingProgress disableShrink />
          }
        </StyledAvatar>
      ) : (
        <Avatar className={className} />
      )}
    </>
  );
}
